@if (contentOverviewState | async; as state) {
  <p-button
    [text]="true"
    data-id="content-overview-toggle"
    [styleClass]="
      'bd-round-left bd-toolbar-button bd-round-right ' +
      (state === 'show' ? 'bd-active' : '')
    "
    (onClick)="onContentOverviewToggleClicked(state)"
  >
    <i class="ui-align-left pr-1"></i>
  </p-button>
}
